import React from "react";
import { cn } from "../../utils/twMerge";

const HeroPill = ({ className, title, subTitle, count, icon, percent }) => {
  return (
    <div
      className={cn(
        "flex gap-2 items-center border border-white rounded-full p-3 justify-between bg-gradient-to-r from-[#B6B7EB] to-[#5789F3]",
        className
      )}
    >
      <div className="flex gap-1 items-center">
        <img
          src={icon}
          alt=""
          className="object-cover size-[40px] md-max:size-[25px]"
        />
        <div className="flex flex-col">
          <p className="text-white font-bold text-[16px] md-max:text-[10px]">
            {title}
          </p>
          <p className="text-white text-[12px] md-max:text-[8px] font-medium">
            {subTitle}
          </p>
        </div>
      </div>
      <div className="bg-[#FBF6DB] text-[18px] md-max:text-[14px] text-[#aa8d00] rounded-full h-max p-2">
        {count}{percent ? "%" : "+"}
      </div>
    </div>
  );
};

export default HeroPill;
